// pick utils
import LuxonUtils from '@date-io/luxon';
import {
  ThemeProvider,
} from '@material-ui/core/styles';
import {
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import {
  Provider,
} from 'mobx-react';
import {
  OptionsObject, SnackbarProvider, SnackbarProviderProps,
} from 'notistack';
import React from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line import/no-unresolved
import YellowDeglaTheme from 'theme';
import App from './App';
import SnackBarComponent from './components/SnackBarComponent/SnackBarComponent';
import './index.module.scss';
import {
  stores,
} from './mobx-store';
import * as serviceWorker from './serviceWorker';

// const ExtendedSnackbarProvider: React.ComponentType<
// SnackbarProviderProps
//   & {
//     ref?: React.RefObject<ExtendedSnackbar>;
//   }
// > = SnackbarProvider;

export interface ExtendedSnackbar extends React.Component<SnackbarProviderProps> {
  handleEnqueueSnackbar: (message: string | React.ReactNode, options?: OptionsObject) => string | number | null;
  handleCloseSnackbar: (key: string | number) => void;
}

const notistackRef = React.createRef<ExtendedSnackbar>();

ReactDOM.render(
  <ThemeProvider theme={YellowDeglaTheme}>
    <SnackbarProvider maxSnack={3} ref={notistackRef}>
      <MuiPickersUtilsProvider utils={LuxonUtils}>
        <SnackBarComponent snackbarRef={notistackRef} />
        <Provider {...stores}>
          <App />
        </Provider>
      </MuiPickersUtilsProvider>
    </SnackbarProvider>
  </ThemeProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
